<!-- 
  定时任务列表
  lovi 2020-07-13
 -->
<template>
  <div>
    <div
      class="scroll-wrapper task-warrper"
      :class="{ noCrad: !taskList.length && getListFlag }"
    >
      <div v-if="!taskList.length && getListFlag" class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>
      <scroll
        ref="scroll"
        :data="taskList"
        :click="false"
        v-if="taskList.length && getListFlag"
      >
        <div class="task">
          <div
            class="task-info"
            v-for="(item, index) in taskList"
            :key="index"
            @click="editTimes(item)"
          >
            <van-swipe-cell :before-close="beforeClose" :name="item.timer_id">
              <van-cell :border="false" is-link>
                <template slot="title">
                  <h3 class="text-hidden">{{ item.label }}</h3>
                  <p class="text-blue">{{ item.money }}</p>
                </template>
                <template slot="default">
                  <h4 class="text-blue">
                    {{
                      item.state == 1
                        ? $t("recharge.open")
                        : $t("recharge.close")
                    }}
                  </h4>
                  <p class="text-gray">
                    {{
                      item.day == 0
                        ? $t("recharge.lastDayOfEveryMonth")
                        : language == "en"
                        ? item.day +
                          (item.day == 1
                            ? "st"
                            : item.day == 2
                            ? "nd"
                            : item.day == 3
                            ? "rd"
                            : "th") +
                          $t("recharge.everyMonth")
                        : $t("recharge.everyMonth") +
                          item.day +
                          $t("common.days")
                    }}
                  </p>
                </template>
              </van-cell>
              <template slot="right">
                <van-button square type="danger" :text="$t('common.delete')" />
              </template>
            </van-swipe-cell>
          </div>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["getTaskList"],
  components: {},
  data() {
    return {
      taskList: [],
      getListFlag: false
    };
  },
  created() {},
  mounted() {
    this.timesRecord();
  },
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    editTimes(data) {
      // 编辑任务
      let vm = this;
      console.log("editTimes", data);
      vm.$emit("getTaskInfo", data);
    },
    beforeClose({ name, position, instance }) {
      //右滑删除点击
      let vm = this;
      switch (position) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          vm.$dialog
            .confirm({
              message: vm.$t("recharge.sureDeleteTask")
            })
            .then(() => {
              vm.deltimes(name);
              instance.close();
            })
            .catch(() => {
              instance.close();
            });
          break;
      }
    },
    deltimes(id) {
      //删除任务
      let vm = this;
      let data = {};
      data.timer_id = id;
      vm.$post("/app/recharge/deltimes", data, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("deltimes", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.timesRecord();
        }
      });
    },
    timesRecord() {
      // 定时任务列表
      let vm = this;
      vm.getListFlag = false;
      vm.$post("/app/recharge/timesRecord", {}, { loading: true }).then(res => {
        console.log("timesRecord", res);
        vm.getListFlag = true;
        vm.taskList = res;
      });
    }
  },
  watch: {
    getTaskList(bol) {
      if (bol) {
        this.timesRecord();
        this.$emit("update:getTaskList", false);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.task-warrper {
  top: 88px !important;
  bottom: 15px !important;
  margin: 0 15px;
  border-radius: 0 0 8px 8px;
  border-top: 1.1px solid #e4e4e4;
}
.task {
  /deep/.van-swipe-cell__right {
    height: calc(100%);
    .van-button {
      height: 100%;
      border-radius: 0;
      font-size: 16px;
    }
  }
  .van-cell {
    align-items: center;
  }
  .task-info {
    border-bottom: 1.1px solid #e4e4e4;
    /deep/.van-cell {
      line-height: 1.2;
      p {
        margin-top: 5px;
      }
      .van-cell__title {
        overflow: hidden;
        h3 {
          font-size: 14px;
          font-weight: 400;
        }
        p {
          font-size: 18px;
          font-weight: 400;
        }
      }
      .van-cell__value {
        flex: initial;
        align-items: flex-end;
        p {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
